import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createNewChannel, addConfluenceChannelConfig } from '../skills_action';
import { Alert, Typography, Input, message } from 'antd';

const { Text } = Typography;

class ConfigureWikiChannelModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new_channel_name: 'troopr-wiki-demo',
    };
    this.createDemoChannel = this.createDemoChannel.bind(this);
  }

  componentDidMount() {
    this.props.setClick(this.createDemoChannel);
  }

  createDemoChannel = async () => {

    try {
      const wikiSKill = this.props.skills.find((skill) => skill.key === 'wiki');
      this.props.setLoadingState(true);

      const data = await this.props
        .createNewChannel(
          this.props.match.params.wId,
          this.state.new_channel_name || 'troopr-wiki-demo'
        )

      if (data && data.success) {
        const res = await this.props
          .addConfluenceChannelConfig(
            this.props.match.params.wId,
            {
              workspace_id: this.props.match.params.wId,
              channel: data.channel,
              spaces: [],
              skill_id: wikiSKill.skill_metadata._id,
            },
              /* addNewone */ true
          )

        if (res.data.success) {

          this.props.moveToNextStep(res.data);
        } else {
          message.error(
            (res && res.data.message) || 'Error while creating channel'
          );

        }

      } else {

        message.error(
          (data && data.message) || 'Error while creating channel'
        );
      }
    } catch (err) {

      message.error(
        (err && err.message) || 'Error while creating channel'
      );
    }
    // this.props.setLoadingState(false);
  };

  render() {
    const { new_channel_name } = this.state;
    return (
      <div>
        <Text>New Channel</Text>
        <Input
          onChange={(e) => {
            this.setState({ new_channel_name: e.target.value });
          }}
          value={new_channel_name}
        />
        <br />
        <br />
        <Text type='warning'>
          Channel names may only contain lowercase letters, numbers, hyphens,
          and underscores. Max length of the channel name is 80 characters.
          Longer names will be automatically truncated.
        </Text>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    skills: state.skills.skills,
  };
};

export default withRouter(
  connect(mapStateToProps, { createNewChannel, addConfluenceChannelConfig })(
    ConfigureWikiChannelModal
  )
);
